import { render, staticRenderFns } from "./Paket.vue?vue&type=template&id=50dbf6ea&scoped=true&"
import script from "./Paket.vue?vue&type=script&lang=js&"
export * from "./Paket.vue?vue&type=script&lang=js&"
import style0 from "./Paket.vue?vue&type=style&index=0&id=50dbf6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dbf6ea",
  null
  
)

export default component.exports